type Handler<T> = (payload: T) => void;

export class EventEmitter<EventMap extends Record<string, unknown>> {
  private handlers: Map<keyof EventMap, Set<Handler<EventMap[keyof EventMap]>>> = new Map();

  on<K extends keyof EventMap>(event: K, handler: Handler<EventMap[K]>): () => void {
    let set = this.handlers.get(event);
    if (!set) {
      set = new Set();
      this.handlers.set(event, set);
    }
    set.add(handler as Handler<EventMap[keyof EventMap]>);
    return () => this.off(event, handler);
  }

  off<K extends keyof EventMap>(event: K, handler: Handler<EventMap[K]>): void {
    this.handlers.get(event)?.delete(handler as Handler<EventMap[keyof EventMap]>);
  }

  emit<K extends keyof EventMap>(event: K, payload: EventMap[K]): void {
    const set = this.handlers.get(event);
    if (!set) return;
    for (const handler of set) {
      try {
        (handler as Handler<EventMap[K]>)(payload);
      } catch (err) {
        console.error(`[EventEmitter] handler for "${String(event)}" threw:`, err);
      }
    }
  }

  removeAll(): void {
    this.handlers.clear();
  }
}
